<template>
  <div class="edit-profilebox add-new-memberbox edit-new-member-page">
    <ul class="breadcrumbs-list">
      <a href="javascript:void(0)" @click="backButton"><li>User Profile</li></a>
      <li>&nbsp;>&nbsp;Edit New Member</li>
    </ul>
    <h4 class="welcome-text">Edit Member</h4>
    <div>
      <div class="edit-profilebox-detail">
        <form
          @submit.prevent
          class="login-form-box register-page bg-dot-img"
          lazy-validation
        >
          <h4>Enter Details</h4>
          <v-row>
            <v-col xs="12" md="6" class="first-inputbox col">
              <v-text-field
                v-model="full_name"
                placeholder="Enter Full Name"
                :error-messages="fullNameErrors"
                label="Full Name*"
                required
                @input="$v.full_name.$touch()"
                @blur="$v.full_name.$touch()"
              ></v-text-field>
            </v-col>
            <v-col xs="12" md="6" class="member_relation_box col">
              <label class="member-label">MEMBER RELATION*</label>
                <v-select
                  v-model="member_relation"
                  :items="relations"
                  filled
                  dense
                  solo
                  @change="dissableGender"
                ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col xs="12" md="6" class="col">
              <v-container fluid>
                <div class="select-radiobox">
                  <label class="laberbox">Gender</label>
                  <div>
                    <label class="container Female" :style="{ 'pointer-events': female_toggled ? 'none' : null }">
                      <input
                        type="radio"
                        checked="checked"
                        name="radio"
                        v-model="gender"
                        value="FEMALE"
                        :style="{ 'pointer-events': female_toggled ? 'none' : null }"
                      />
                      <span class="checkmark" :style="{ 'pointer-events': female_toggled ? 'none' : null }"> Female </span>
                    </label>
                    <label class="container male" :style="{ 'pointer-events': male_toggled ? 'none' : null }">
                      <input
                        type="radio"
                        checked="checked"
                        name="radio"
                        v-model="gender"
                        value="MALE"
                        :style="{ 'pointer-events': male_toggled ? 'none' : null }"
                      />
                      <span class="checkmark" :style="{ 'pointer-events': male_toggled ? 'none' : null }"> Male </span>
                    </label>
                    <label class="container other" :style="{ 'pointer-events': others_toggled ? 'none' : null }">
                      <input
                        type="radio"
                        checked="checked"
                        name="radio"
                        v-model="gender"
                        value="OTHERS"
                        :style="{ 'pointer-events': others_toggled ? 'none' : null }"

                      />
                      <span class="checkmark" :style="{ 'pointer-events': others_toggled ? 'none' : null }"> Others </span>
                    </label>
                  </div>
                </div>
              </v-container>
            </v-col>
            <v-col xs="12" md="6" class="dob-box col" v-if="actual_dob_show">
              <label>DATE OF BIRTH <a href="javascript:void(0)" v-on:click="showFullInfo('dob')"
                  title="Show Full DOB Detail" style="margin-left: 242px;">Show/Edit</a></label>
              <Datepicker
                v-model="date"
                format="dd MMM, yyyy"
                :disabledDates="disabledDates"
                 @selected="checkAge($event)"
              ></Datepicker>
            </v-col>
            <v-col class="dob-box col" v-else>
              <label>DATE OF BIRTH <a href="javascript:void(0)" v-on:click="showFullInfo('dob')"
                  title="Show Full DOB Detail" style="margin-left: 175px;">Show/Edit</a></label>
              <v-text-field v-model="masked_date" disabled v-if="masked_date !=''"></v-text-field>
              <Datepicker v-model="date" format="dd MMM, yyyy" :disabledDates="disabledDates"  @selected="checkAge($event)" v-else></Datepicker>
            </v-col>
          </v-row>
          <v-row>
            <v-col xs="12" md="6" class="col">
              <v-text-field
                v-model="email"
                placeholder="Enter Email"
                :error-messages="emailErrors"
                label="Email Address"
                required
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              ></v-text-field>
            </v-col>
            <v-col class="col mobile-box" xs="12" md="6">
                <v-col class="d-flex">
                  <v-select
                    disabled
                    v-model="country_code"
                    :items="items"
                    filled
                    dense
                    solo
                  ></v-select>
                </v-col>
                <v-text-field
                  :class="isAddClassPhoneNumber"
                  v-model="phonenumber"
                  placeholder="Enter Mobile"
                  :error-messages="phonenumberErrors"
                  label="Mobile"
                  @input="$v.phonenumber.$touch()"
                  @blur="$v.phonenumber.$touch()"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
           
            <v-col xs="12" md="6" class="col">
              <label>PAN <a href="javascript:void(0)" v-on:click="showFullInfo('pancard')"
                  title="Show Full Pan Card Detail" style="margin-left:240px !important;">Show/Edit</a></label>
              <v-text-field
                v-bind:class="{'pan-cardbox': isAddClass}"
                v-model="pancard"
                placeholder="Enter PAN"
                :disabled="is_pancard_disabled"
                
                @input="customPanError"
              ></v-text-field>
              <span v-bind:class="{'error-messagebox-login': isAddClassServerError}" id="pan_side_error">{{panError}}</span>
            </v-col>

          
          </v-row>
          <span
            v-bind:class="{'error-messagebox-login': isAddClassServerError}"
            id="server_side_error"
            >{{serverError}}
          </span>
          <v-row class="buttonbox">
            <v-btn class="blue-border-btn" @click="backbutton"> Cancel </v-btn>
            <v-btn
              class="blue-btn"
              @click="submit"
              :disabled="!isFormValid"
              :error-messages="buttonErrorMessage"
            >
              Update
            </v-btn>
          </v-row>
        </form>
        <v-row justify="center">
          <v-dialog v-model="verify_otp_dialog_status" persistent max-width="290">
            <v-card cols="6">
              <v-card-title>
                <span class="text-h5">Verify OTP</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form ref="form" id="verify_otp" v-model="valid" lazy-validation @submit.prevent>
                    <v-row>
                      <v-col>
                        <label>OTP*</label>
                        <v-text-field name="otp" v-model="otp" ref="otp" placeholder="Enter OTP send on mobile no."></v-text-field>
                        <p style="color:red;" v-if="otp_error">{{ error_text }}</p>
                        <p style="font-size:13px;">You will receive an otp on ******{{mob_last_four}}</p>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="verifyOtp">
                  Verify
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import { GET_FAMILY_MEMBER_DETAIL, UPDATE_FAMILY_MEMBER_DETAIL, GET_FAMILY_MEMBER_LIST, UPDATE_PROFILE_DETAIL, VERIFY_EMAIL_OTP } from "../../store/actions.type";
import axios from 'axios';
import Datepicker from 'vuejs-datepicker'
import { validationMixin } from 'vuelidate'
import moment from 'moment'
import {
    required,
    email,
    minLength,
    sameAs,
    isAlphanumeric,
    alpha,
    numeric,
    maxLength
} from "vuelidate/lib/validators";
import { Auth } from 'aws-amplify';
export default {
  components: {
        Datepicker
    },
  mixins: [validationMixin],

    validations: {
      email: {  email },
      full_name:{ required, maxLength: maxLength(50), validateAlpha:function(value){
        const alpha_str = /^[a-zA-Z\-\s]+$/.test(value)
        return alpha_str
      }},
      phonenumber:{ numeric,maxLength:maxLength(10),minLength:minLength(10)},
    },

  data: () => ({
    full_name: '',
    gender: '',
    email:'',
    phonenumber:'',
    pancard:'',
    cognito_idp:'',
    profile_image:'',
    users:{},
    submitted: false,
    isAddClass: true,
    isMobileNo:true,
    genderValidate:'',
    country_code:'+91',
    items:['+91'],
    activePicker: null,
    date: null,
    menu: false,
    isFormValid:false,
    disabledDates: {
          from: new Date()
        },
    serverError:'',
    panError:'',
    isAddClassServerError:false,
    member_relation:'',
    relations:[],
    disabledItems:[],
    female_toggled:false,
    male_toggled:false,
    others_toggled:false,
    isAddClassPhoneNumber:'none',
    full_pancard: "",
    full_dob: "",
    actual_dob_show: false,
    verify_otp_dialog_status: false,
    getFormData: '',
    valid: null,
    mob_last_four:'',
    otp_error: false,
    error_text: '',
    unmasking_field_type: '',
    masked_date: '',
    is_pancard_disabled:true,
    otp:"",
    all_member_list:[]
  }),

   watch: {
      menu (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      },
      pancard(val)
      {
        this.pancard = val.toUpperCase();
        this.customPanError();
      }
    },

  computed: {
    fullNameErrors() {
      const errors = [];
      this.serverError='';
      this.isAddClassServerError = '';
      if (!this.full_name) {
        this.isFormValid = false;
      }
      if (!this.$v.full_name.$dirty) return errors;
      !this.$v.full_name.required && errors.push("Name is required");
      !this.$v.full_name.maxLength && errors.push("Name can't be greater than 50 characters");
      !this.$v.full_name.validateAlpha && errors.push("Full name must be alphabet");
      return errors;
    },
    emailErrors() {
      const errors = [];
      this.serverError='';
      this.isAddClassServerError = '';
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      return errors;
    },
    phonenumberErrors() {
      if(this.$v.phonenumber.$dirty && this.$v.phonenumber.numeric && this.$v.phonenumber.minLength && this.$v.phonenumber.maxLength&& this.phonenumber){
        this.isAddClassPhoneNumber = 'pan-cardbox';
      }
      else{
        this.isAddClassPhoneNumber = 'none';
      }
     const errors = [];
     this.serverError='';
     this.isAddClassServerError = '';
      if (!this.$v.phonenumber.$dirty) return errors;
      !this.$v.phonenumber.numeric && errors.push("Mobile Number must be numeric");
      !this.$v.phonenumber.minLength && errors.push("Mobile Number must be 10 digit");
      !this.$v.phonenumber.maxLength && errors.push("Mobile Number must be 10 digit");
      return errors;
    },
    buttonErrorMessage(){
      if(!this.full_name){
        this.isFormValid = false;
      }else if(this.full_name.length > 50){
        this.isFormValid = false;
      }else if(!this.$v.full_name.validateAlpha){
        this.isFormValid = false;
      }else if(!this.member_relation){
        this.isFormValid = false;
      }else if(this.email && !this.$v.email.email){
          this.isFormValid = false;
      }else if(this.phonenumber && (!this.$v.phonenumber.numeric || !this.$v.phonenumber.minLength || !this.$v.phonenumber.maxLength)){
          this.isFormValid = false;
      }else if(!this.date){
        this.isFormValid = false;
      }else if(this.panError){
        this.isFormValid = false;
      }else{
        this.isFormValid = true;
      }
    },
  },

  created (){  
    let cognito_idp = atob(localStorage.getItem("cognito_idp"));
    let formdata = new FormData();
    formdata.append("aws_cognito_id", cognito_idp);
   
    axios.post(process.env.VUE_APP_ROOT_API + "get-member-type-list", formdata).then((response) => {
          response.data.data.forEach(member_type_detail => {
            this.relations.push({value:member_type_detail.id, text:member_type_detail.type});
            this.all_member_list.push({type:member_type_detail.type, is_18_plus_age_required:member_type_detail.is_18_plus_age_required})
					})
      })
      .catch(() => {
        
      }); 
    this.$store.dispatch(GET_FAMILY_MEMBER_DETAIL, {
      data: {
        aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
        member_id:atob(this.$route.params.editId),
      },
      api: 'get-family-member-detail', 
    }).then(() => {
      let response = this.$store.getters.getFamilyMemberDetail;
      if (response.status == 'error') {
        return [];
      }else{
        this.full_name = response.data.name;
        this.email = response.data.email  == 'N/A' ? '' : response.data.email;
       // this.date = response.data.dob == 'N/A' ? '' : response.data.dob;
        
        if(response.data.dob == 'NA'){
          this.date = '';
          this.masked_date = '';
          this.full_dob = '';
        }
        else{
          this.date = response.data.dob;
          this.full_dob = response.data.dob;
          this.masked_date = moment(response.data.dob).format('DD MMM') + ', ****';
        }
        this.member_relation = {text:response.data.type,value:response.data.member_type_id};
        if(response.data.pan ==undefined || response.data.pan ==null || response.data.pan =='' || response.data.pan =='N/A' ){
          this.is_pancard_disabled= false
        }
        this.full_pancard = response.data.pan;
        this.pancard = response.data.pan == 'N/A' ? '' : response.data.pan.substring(0, 4) + '******';
        this.phonenumber = response.data.mobile_no == 'N/A' ? '' : response.data.mobile_no;
        this.gender = response.data.gender == false ? '' : response.data.gender
        this.pancard ? this.isAddClass = true : this.isAddClass = false;
        this.phonenumber ? this.isAddClassPhoneNumber = 'pan-cardbox' : this.isAddClassPhoneNumber = 'none';
        if(this.member_relation.text == 'Father'){
          this.gender = this.gender;
          this.female_toggled = true;
          this.others_toggled = false;
          this.male_toggled = false;
        }else if (this.member_relation.text == 'Son') {
          this.gender = this.gender;
          this.female_toggled = true;
          this.others_toggled = false;
          this.male_toggled = false;
        }
        else if (this.member_relation.text == 'Mother') {
          this.gender = this.gender;
            this.male_toggled = true;
            this.others_toggled = false;
            this.female_toggled = false;
        }else if (this.member_relation.text == 'Daughter') {
            this.gender = this.gender;
            this.male_toggled = true;
            this.others_toggled = false;
            this.female_toggled = false;
        }
        else if (this.member_relation.text == 'Spouse') {
          this.gender = this.gender;
          this.male_toggled = false;
          this.others_toggled = false;
          this.female_toggled = false;
        }
      }
    })
    .catch(function (error) {

    });
  },

  methods: {
    customPanError(){
      if (!this.is_pancard_disabled) {
        const panStr = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(this.pancard)
        if(this.pancard == ""){
          this.panError = '';
        }
        else if(panStr){
          this.isAddClass = true;
          this.panError = '';
        }
        else {
          this.isAddClassServerError = true;
          this.isAddClass = false;
          this.panError = 'Invalid PAN number.';
        }
      }
    },
    dissableGender(){
      if(this.member_relation.text == 'Father'){
        this.gender = 'MALE';
        this.female_toggled = true;
        this.others_toggled = false;
        this.male_toggled = false;
      }else if (this.member_relation.text == 'Son') {
        this.gender = 'MALE';
        this.female_toggled = true;
        this.others_toggled = false;
        this.male_toggled = false;
      }
      else if (this.member_relation.text == 'Mother') {
        this.gender = 'FEMALE';
          this.male_toggled = true;
          this.others_toggled = false;
          this.female_toggled = false;
      }else if (this.member_relation.text == 'Daughter') {
          this.gender = 'FEMALE';
          this.male_toggled = true;
          this.others_toggled = false;
          this.female_toggled = false;
      }
      else if (this.member_relation.text == 'Spouse') {
        this.gender = '';
        this.male_toggled = false;
        this.others_toggled = false;
        this.female_toggled = false;
      }
    },

    save (date) {
      this.$refs.menu.save(date)
    },

    submit(e) {
      this.submitted = true;
      this.$loading(true);
      this.date = this.$moment((this.date)).format('YYYY-MM-DD')
      this.date = this.date == 'Invalid date' ? '':this.date;
      let data = {
        member_id:atob(this.$route.params.editId),
        aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
        name:this.full_name,
        member_type_id:this.member_relation.value,
        gender:this.gender,
        dob:this.date,
        email:this.email,
        mobile_no:this.phonenumber
      }
      if (!this.is_pancard_disabled) {
        data.pan = this.pancard
      }
      else {
        data.pan = this.full_pancard
      }
      this.$store.dispatch(UPDATE_FAMILY_MEMBER_DETAIL, {
        data: data,
        api: 'update-family-member-detail', 
      }).then(() => {
        let response = this.$store.getters.getUpdatefamilyMemberDetail;
        this.$loading(false)
        if (response.status == 'error') {
          this.isAddClassServerError = true;
          this.serverError = response.message;
          return [];
        }else{
          this.appendMemberData()
          Toast.fire({
            icon: 'success',
            title: 'Member detail updated successfully.'
          })
          setTimeout(() => {
            this.$router.push({ name: 'dashboard' }).catch(()=>{})
          }, 1500);
        }
      })
      .catch((error) =>  {
        this.$loading(false)
      });
    },
    backbutton(evt){
      this.$router.push({ name: 'dashboard' }).catch(()=>{});
    },
    backButton(){
      this.$router.push({ name: 'dashboard' }).catch(()=>{});
    },
    appendMemberData(){
      this.$store.dispatch(GET_FAMILY_MEMBER_LIST, {
        data: {
          aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
        },
        api: 'get-family-member-list', 
      }).then(() => {
        let response = this.$store.getters.getFamilyMemberList;
        if (response.status == 'error') {
          this.isAddClassServerError = true;
          this.serverError = response.message;
          return [];
        }
        else {
          let updatedDetail = [
            {key:'allow_add_family_member', value:response.allow_add_family_member},
            {key:'show_add_family_member_button', value:response.show_add_family_member_button},
            {key:'family_member_list', value:response.data},
          ]
          this.$store.dispatch(UPDATE_PROFILE_DETAIL,updatedDetail)
          return true;
        }
      });
    },

    showFullInfo(type) {
      this.otp_error = false
      this.otp = ''
      this.unmasking_field_type = type
      this.$store.dispatch(VERIFY_EMAIL_OTP, {
        data: {
          mobile_no:this.$store.getters.getUserDetails.mobile_no,
          aws_cognito_id: localStorage.getItem('cognito_idp'),
        },
        api: 'send-otp',
      }).then(() => {
        this.verify_otp_dialog_status = true
        this.mob_last_four=this.$store.getters.getUserDetails.mobile_no.substr(9);
      }).catch(function (error) {

      });
    },

    verifyOtp() {
      this.getFormData = document.querySelector("#verify_otp");
      if (this.getFormData.otp.value != '') {
        let formdata = new FormData();
        formdata.append("aws_cognito_id", localStorage.getItem('cognito_idp'));
        formdata.append("otp", this.getFormData.otp.value);
        formdata.append("mobile_no",this.$store.getters.getUserDetails.mobile_no);
        axios.post(process.env.VUE_APP_ROOT_API + 'verify-otp', formdata).then((res) => {
          if (res.data.status == 'error') {
            this.otp_error = true
            this.error_text = 'Wrong OTP.'
          }
          else {
            this.getFormData.otp.value = '';
            if (this.unmasking_field_type == 'pancard') {
              this.is_pancard_disabled = false
              this.pancard = this.full_pancard
            }
            else if (this.unmasking_field_type == 'dob') {
              this.actual_dob_show = true
            }
            this.verify_otp_dialog_status = false
            this.otp_error = false
          }
        }).catch(() => {

        });
      }
      else {
        this.otp_error = true
        this.error_text = 'OTP Required.'
      }
    },

    close() {
      this.verify_otp_dialog_status = false
    },

    checkAge(event){
      console.log('h')
      this.all_member_list.forEach(member_type_detail => {
				if( this.member_relation == member_type_detail.type && member_type_detail.is_18_plus_age_required == 1){
          swal.fire({title:"Age must be greater than 18 years"}); 
        }
			})
    }
  }
};
</script>